import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateOrUpdateNoiseEventPolicyOverride } from 'app/__generated__/global';
import { QUERY_KEY } from 'app/business-logic/services/enums';
import { createOrUpdateNoiseEventPolicyOverride } from 'app/business-logic/services/noise-service/createOrUpdateNoiseEventPolicyOverride';

export const useUpdateNoiseEventPolicyOverride = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (params: CreateOrUpdateNoiseEventPolicyOverride) => {
      return createOrUpdateNoiseEventPolicyOverride(params);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY.noiseEventsByAlertId],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY.noiseEventHistory],
      });
    },
  });
  return { mutateAsync, isPending };
};
